import Servico from './Servico'

class QuestionarioServico extends Servico {
  constructor() {
    super('questionario')
  }
}

export default QuestionarioServico
